import React from "react";
import Paper from "@mui/material/Paper";
import Avatar from "@mui/material/Avatar";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import { useHomePage } from "../../contexts/HomePage";
import { useBasicInfo } from "../../contexts/BasicInfo";
import { useGeneralProfile } from "../../contexts/Organization";
import { useAuth } from "../../contexts/Auth";
import { treatment_program } from "../../constants/common";

const PostForm = () => {
  const { account_type, isMentalHealthProfessional, permissions } = useAuth();
  const { handleOpenCreatePostModal } = useHomePage();
  const { data } = useBasicInfo();
  const { facilityInfo } = useGeneralProfile();
  const info =
    account_type === treatment_program && !isMentalHealthProfessional()
      ? facilityInfo
      : data;

  return (
    <Paper
      sx={{
        boxShadow: "none",
        borderColor: "border.main",
        p: 3,
      }}
      component="form"
    >
      <Box
        sx={{
          display: "flex",
          gap: 1,
        }}
      >
        <Avatar
          sx={{
            width: 48,
            height: 48,
          }}
          src={info?.main_image}
        />
        <Box position="relative" flexGrow={1}>
          {permissions?.post_add && (
            <Box
              sx={{
                position: "absolute",
                width: "100%",
                height: "100%",
                cursor: "pointer",
                zIndex: 9,
              }}
              onClick={handleOpenCreatePostModal}
            />
          )}
          <TextField
            placeholder="Create a post"
            multiline
            fullWidth
            disabled={!permissions?.post_add}
            InputProps={{
              sx: {
                py: 1.6,
                px: 1,
                textarea: {
                  fontSize: 14,
                  lineHeight: "22px",
                  "&::placeholder": {
                    fontWeight: 700,
                  },
                },
              },
            }}
          />
        </Box>
      </Box>
    </Paper>
  );
};

export default PostForm;
